import React from 'react';
import PropTypes from 'prop-types';

import styles from './CloseButton.scss';
import closeImg from './img/close.png';

export default function CloseButton({onClick, altText}) {
	return (
		<button onClick={onClick} className={styles.container}>
			<img src={closeImg} alt={altText}/>
		</button>
	);
}

CloseButton.propTypes = {
	onClick: PropTypes.func.isRequired,
	altText: PropTypes.string.isRequired,
};